import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPQantSpeak = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6097_794)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 8,
				width: 2,
				height: 18,
				rx: 1,
				fill: "#005AFF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 3,
				width: 2,
				height: 12,
				rx: 1,
				fill: "#32C8DC"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 12,
				y: 3,
				width: 2,
				height: 12,
				rx: 1,
				fill: "#32C8DC"
			}),
			/* @__PURE__ */ _jsx("rect", {
				y: 6,
				width: 2,
				height: 6,
				rx: 1,
				fill: "#005AFF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 16,
				y: 6,
				width: 2,
				height: 6,
				rx: 1,
				fill: "#005AFF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6097_794",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgPQantSpeak;
